import React from 'react';
import Button from '@mui/material/Button';
import { login } from '../authentication';
import { useTranslation } from 'react-i18next';

// Login button component with MSAL
const LoginButton = () => {

    const { t } = useTranslation();
    const handleLogin = () => {
        login("/manage");
    };

    return (
        <Button
            variant="contained"
            onClick={handleLogin}
            sx={{
                minWidth: '120px',
                textTransform: 'none'
            }}
        >
            {t('login')}
        </Button>
    );
};

export default LoginButton;